@if (data$ | async; as component) {
  <div class="accordion-container">
    <div class="title">{{component.title}}</div>
    @if (items$ | async; as components) {
      <div class="accordion-items-list">
        @for (component of components; track component) {
          @if (component) {
            <app-custom-item-accordion [item]="component"></app-custom-item-accordion>
          }
        }
      </div>
    }
  </div>
}
